import React, { useEffect } from 'react';

import useCalculateInsurance from '../../hooks/useCalculateInsurance';
import { 
  Company, 
  InsuranceParameters, 
  Offers, 
  IInsurance, 
  SetInsurance,
  SetInsuranceParameters 
} from '../../types';
import LoadingIndicator from '../../ui/LoadingIndicator';
import InsuranceCard from '../InsuranceCard';
import { Wrapper } from './styles';

type Props = {
  insurance: IInsurance;
  insuranceParameters: InsuranceParameters;
  setInsurance: SetInsurance;
  setInsuranceParameters: SetInsuranceParameters;
};

const InsuranseCardsList: React.FC<Props> = (
  { 
    insurance, 
    insuranceParameters, 
    setInsurance, 
    setInsuranceParameters 
  }) => {
  const { getOffers, availableOffers, isLoading } = useCalculateInsurance();  

  useEffect(() => {
    getOffers(insurance);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insurance]);
  const companies = availableOffers?.offersResponce?.companies;
  const companiesWithOffers = companies?.filter(
    (company: any) => company.offers.length > 0
  );
  
  companiesWithOffers?.sort(
    (a: Company, b: Company) => (  a.offers?.[0]?.amount?.mdl > b.offers?.[0]?.amount?.mdl ) ? 1 : -1 
  );
  

  if (isLoading) return <LoadingIndicator />;

  return (
    <Wrapper>
      {companiesWithOffers?.map((company: Company) => {
        return company.offers.map((offer: Offers) => {
          return (
            <InsuranceCard
              key={company.name}
              offer={offer}
              company={company}
              insurance={insurance}
              insuranceParameters={insuranceParameters}
              setInsurance={setInsurance}
              setInsuranceParameters={setInsuranceParameters}
            />
          );
        });
      })}
    </Wrapper>
  );
};

export default InsuranseCardsList;
